import React from 'react'

export default function ConfirmMail() {
   return (
      <>
      <div class="main-wrapper">
          <div class="error-box mt-20">
              <div class="error-box-img"><img class="img-fluid" src={"../../theme/assets/img/success.png"} alt="" /></div>
              <h3 class="h2 mb-3 fg-green"> Success </h3>
              <p class="h4 font-weight-normal">Your new password has been reset successfully!</p>
          </div>
      </div>
      </>
   )
}
